package co.maytes.standupbot.dashboard.components.motion

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Motion
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier

private const val DIMMED_OPACITY = "0.6"

@Composable
fun Revalidating(
    refreshing: Boolean,
    content: @Composable () -> Unit,
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .attrsModifier { attr("aria-busy", refreshing.toString()) }
            .styleModifier {
                property("opacity", if (refreshing) DIMMED_OPACITY else "1")
                property("pointer-events", if (refreshing) "none" else "auto")
                property("transition", "opacity ${Motion.DUR_FAST} ${Motion.EASE_STANDARD}")
            },
    ) {
        content()
    }
}
